<input type="text" class="form-control" id="tagInput" [(ngModel)]="tagInput" (keydown.enter)="addTag()" />

<div class="tags mt-2">
  <span *ngFor="let tag of tags" class="badge badge-secondary font mr-1 mt-1 p-2">
    {{ tag }}
    <span (click)="removeTag(tag)" style="cursor: pointer;" class="pl-2">
      <i class="la la-times font" style="color: black;"></i>
    </span>
  </span>
</div>